import { URL_BASE } from "./constants";
import { loadPackets } from "../redux/actions/jobcoinsPacketActions";
import { get, deleteRequest, handleErrors, put, post } from "./requests";
import { Store } from "../redux/store";

async function getAllPackets() {
    const url = `${URL_BASE}/jobcoinspackets`;
    const packets = await get(url);
    Store.dispatch(loadPackets(packets.data));
    return packets.data;
}

async function addPacket(price, totalCoins, bonusCoins) {
    const packet = {
        totalCoins,
        price,
        bonusCoins
    };
    const url = `${URL_BASE}/jobcoinspackets/create`;
    const token = Store.getState().authState.loggedUser;
    await post(url, packet, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllPackets();
}

async function updatePacket(id, price, totalCoins, bonusCoins) {
    const packet = {
        id,
        totalCoins,
        price,
        bonusCoins
    };
    const url = `${URL_BASE}/jobcoinspackets/edit`;
    await put(url, packet, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllPackets();
}

async function deletePacket(id) {
    const url = `${URL_BASE}/jobcoinspackets/delete/${id}`;
    await deleteRequest(url, null, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    getAllPackets();
}

export default {
    getAllPackets,
    addPacket,
    updatePacket,
    deletePacket
};